import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { FilterPipe } from "../../../pipes/filter.pipe";
import { Int_Menu_Items } from "../../../models/components";

@Component({
  selector: "mobi-office-lib-mat-option-drop-down",
  templateUrl: "./mat-option-drop-down.component.html",
  styleUrl: "./mat-option-drop-down.component.scss",
  imports: [MatMenuModule, FormsModule, CommonModule, MatIconModule, FilterPipe],
})
export class MatOptionDropDownComponent implements OnInit, AfterViewInit {
  constructor() {}

  ngOnInit(): void {
    if (this.isMultipleSelected) {
      this.optionList.map(el => {
        el.isSelected = this.model.includes(el.ID);
      });
    } else {
      this.optionList.map(el => {
        el.isSelected = this.model == el.ID;
      });
    }

    if (this.isSortBySelected) {
      this.optionList?.sort((a, b) => {
        if (a.isSelected && !b.isSelected) {
          return -1;
        } else if (!a.isSelected && b.isSelected) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  ngAfterViewInit(): void {
    if (this.searchInput?.nativeElement) this.searchInput.nativeElement?.focus();

    // Get Option Elements
    setTimeout(() => {
      this.optionElements = document.querySelectorAll(".mat-option-menu-container > .menu-option");
    }, 0);
  }

  @ViewChild("searchInput") searchInput!: ElementRef;

  @Input()
  isMultipleSelected: boolean = false;
  @Input() isSearchable: boolean = false;
  @Input() triggerElement?: MatMenuTrigger;
  @Input({ required: true }) optionList: Int_Menu_Items[] = [];
  @Input() model: any;
  @Input() label: string = "";
  @Input() notFoundText: string = "Not Found";
  @Input() isClearable: boolean = false;
  @Input() isSortBySelected: boolean = true;
  @Input() customClass: string = "";
  @Input() isShowArrows: boolean = true;

  @Output() changeEmitter = new EventEmitter();
  @Output() modelChange = new EventEmitter();
  private optionElements: any = [];

  searchText: string = "";

  onSearchKeyDown($event: KeyboardEvent) {
    if (this.optionElements.length && $event.code === "ArrowDown") {
      this.optionElements[0].focus();
    }
  }

  onOptionKeyDown($event: KeyboardEvent) {
    const activeEle = document.activeElement as HTMLElement;
    if (!activeEle) return;

    // Ensure active element is within the option elements
    const activeEleIndex = Array.prototype.indexOf.call(this.optionElements, activeEle);
    if (activeEleIndex === -1) return;

    if ($event.key === "Enter") {
      $event.preventDefault();

      const dataId = ($event?.target as any)?.dataset?.id;
      if (!dataId) return;
      const item = this.optionList.find(el => el.ID == dataId);
      if (item) this.onSelectOption(item);
    }

    if ($event.key === "ArrowDown") {
      $event.preventDefault();
      if (activeEleIndex < this.optionElements.length - 1) {
        (activeEle.nextElementSibling as HTMLElement)?.focus();
      }
    }

    if ($event.key === "ArrowUp") {
      $event.preventDefault();
      if (activeEleIndex > 0) {
        (activeEle.previousElementSibling as HTMLElement)?.focus();
      }
    }
  }

  onHandleParent($event: Event) {
    if (this.isSearchable || this.isMultipleSelected) $event?.stopPropagation();
  }

  onSelectOption(item: Int_Menu_Items) {
    if (this.isMultipleSelected) {
      item.isSelected = !item.isSelected;
      this.model = this.optionList.filter(el => el.isSelected)?.map(el => el.ID);
      this.modelChange.emit(this.model);
    } else {
      if (item.isSelected && this.isClearable) {
        this.optionList.map(el => {
          el.isSelected = false;
        });
        this.model = 0;
      } else {
        this.optionList.map(el => {
          el.isSelected = false;
        });
        item.isSelected = true;
        this.model = item.ID;
      }

      this.modelChange.emit(this.model);
      this.triggerElement?.closeMenu();
    }

    this.changeEmitter.emit(item);
  }

  onEnter() {
    // Filter the optionList to find all elements whose Name property (case-insensitively trimmed)
    // matches the searchText (case-insensitively trimmed).
    const noOfMatchings = this.optionList.filter(el => el.Name?.toLowerCase()?.trim().includes(this.searchText?.toLowerCase()?.trim()));

    // If there is more than one matching element, exit the function early.
    if (noOfMatchings?.length > 1) return;

    // Find the first element in the optionList whose Name property matches the searchText.
    const selectedItem = this.optionList.find(el => el.Name?.toLowerCase()?.trim().includes(this.searchText?.toLowerCase()?.trim()));

    // If no matching element is found, exit the function early.
    if (!selectedItem) return;

    // Call the onSelectOption method with the selected item.
    this.onSelectOption(selectedItem);

    // Clear the searchText.
    this.searchText = "";
  }
}
